export default __webpack_public_path__ + "static/media/slide02.d64b76ec.webp";